import { useRef, useState } from "react";
import LogoW from "../../src/images/logo1.png";
import Arrow from "../../src/images/arrow.svg";
import { FaLinkedinIn } from "react-icons/fa";
import { IoLogoInstagram } from "react-icons/io";
import { FaTwitter } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaApple } from "react-icons/fa";
import { DiAndroid } from "react-icons/di";
import { IoPerson } from "react-icons/io5";
import { Link } from "react-router-dom";
import { FaPinterest } from "react-icons/fa6";
const TopFooter = () => {
  const [iserror, SetIserror] = useState(false);
  const [isdone, SetIsdone] = useState(false);
  const [message, setMessage] = useState(null);

  const emailInpt = useRef(null);
  const handlerSubmit = () => {
    const emailValue = emailInpt.current.value.trim();

    if (!emailValue || !emailValue.includes("@")) {
      SetIsdone(false);
      SetIserror(true);
      setMessage(<p className="text-base text-white">Enter a valid Email</p>);
    } else {
      SetIserror(false);
      SetIsdone(true);
      setMessage(
        <p className="text-lg text-white ">
          Thank you for subscribing to our newsletter! Stay tuned for updates,
          tips, researches and events delivered straight to your inbox.
        </p>
      );
    }
  };

  return (
    <>
      <div className="px-4 md:px-7 lg:px-10 py-10 2xl:py-12 bg-blkbg">
        <div className="container m-auto">
          <div className="grid grid-cols-1 md:grid-cols-[1fr_2fr_1fr] gap-4">
            <div>
              <div>
                <Link to="/">
                  <img src={LogoW} alt="Logo" className="max-w-32 w-full" />
                </Link>
              </div>
              <div className="flex gap-2 mt-6">
                <a href="https://in.pinterest.com/fastbetter/">
                  <div className="w-7 border rounded-[50%] h-7 flex justify-center items-center">
                    <FaPinterest className="text-white text-xs" />{" "}
                  </div>
                </a>
                <a href="https://www.instagram.com/fast.better/">
                  <div className="w-7 border rounded-[50%] h-7 flex justify-center items-center">
                    <IoLogoInstagram className="text-white text-xs" />
                  </div>
                </a>{" "}
                <div className="w-7 border rounded-[50%] h-7 flex justify-center items-center">
                  <FaTwitter className="text-white text-xs" />
                </div>
                <div className="w-7 border rounded-[50%] h-7 flex justify-center items-center">
                  <FaFacebookF className="text-white text-xs" />
                </div>
              </div>
            </div>

            <div className="flex flex-col xs:flex-row gap-5 justify-between md:gap-8">
              <div className="flex flex-col gap-3 text-base">
                <h3 className="text-orgbg">COMPANY</h3>
                <div className="flex flex-col gap-3 text-white">
                  <Link to="/about">About Us</Link>
                </div>
              </div>
              <div className="flex flex-col gap-3 text-base">
                <h3 className="text-orgbg">HELP</h3>
                <div className="flex flex-col gap-3 text-white">
                  <Link to="/help-center">Help center</Link>
                  <Link to="/contact-us">Contact us</Link>
                </div>
              </div>
              <div className="flex flex-col gap-3 text-base">
                <h3 className="text-orgbg">RESOURCES</h3>
                <div className="flex flex-col gap-3 text-white">
                  <Link to="https://blog.fastbetter.com/">Blogs</Link>
                </div>
              </div>
              <div className="flex flex-col text-white gap-3 text-base">
                <h3 className="text-orgbg">GET THE APP</h3>
                <div className="gap-3">
                  <div className="border-headingColor border px-5 rounded-[40px] flex justify-center items-center mb-4 py-2 gap-1 w-32">
                    <FaApple className="text-white text-lg" /> Ios
                  </div>

                  <a href="https://play.google.com/store/apps/details?id=fastbetter.fastingtracker.weightloss">
                    <div className="border-headingColor border px-5 rounded-[40px] flex justify-center items-center mb-4 py-2 gap-1 w-32">
                      <DiAndroid className="text-white text-lg" /> Android
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <h3 className="text-orgbg">ADDRESS</h3>

              <p className="text-white">
                115, Griva Digeni Avenue Limassol, 3101, Cyprus
              </p>
              <p className="text-white mb-3">
                Victory House, Arch. Makarios III Avenue 205, Limassol 3030,
                Cyprus
              </p>

              {!isdone ? (
                <div className="relative max-w-[250px] sm:max-w-[280px] 2xl:max-w-[350px] w-full">
                  <input
                    ref={emailInpt}
                    id="username"
                    placeholder="Enter your email"
                    className="pl-8 md:pr-12 py-2 rounded-[40px] focus:outline-none focus:ring-0 placeholder:text-base placeholder:font-normal placeholder:text-[#bebbbb] h-11 md:h-12 w-full bg-ltblkbg pr-12 text-white"
                    type="email"
                  />
                  <span className="absolute left-3 top-1/2 transform -translate-y-1/2">
                    <IoPerson className="text-[#bebbbb]" />
                  </span>
                  <span
                    onClick={handlerSubmit}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 h-8 w-8 rounded-[50%] bg-orgbg flex justify-center items-center"
                  >
                    <img alt="Arrow" src={Arrow} className="w-3" />
                  </span>
                </div>
              ) : (
                message
              )}

              {iserror && message}

              <p className="text-white text-xs">
                Join our newsletter to keep up to date with us!
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopFooter;
